import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Email } from '../../models/models';

@Component({
    selector: 'send-email-popup',
    templateUrl: './send-email-popup.component.html',
    standalone: false
})
export class SendEmailPopup implements OnInit {
    @Input() emailTo: string = "";
    @Input() emailCC: string = "";
    @Input() emailSubject: string = "";
    @Input() emailBody: string = "";

    constructor() {
    }

    ngOnInit() {
        //console.log(this.emailTo, this.emailSubject, this.emailBody);
    }
}

@Component({
    selector: 'send-email-dialog',
    templateUrl: './dialog.component.html',
    standalone: false
})
export class SendEmailDialog {
    public emailTo: string = "";
    public emailCC: string = "";
    public emailSubject: string = "";
    public emailBody: string = "";
    public selectedCCEmails: Email[] = [];
    public ccEmails: Email[] = [];

    constructor(public dialogRef: MatDialogRef<SendEmailDialog>, @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.selectedCCEmails = this.ccEmails;
    }

    select(): void {
        this.dialogRef.close({ emailTo: this.emailTo, emailCC: this.emailCC, ccEmails: this.ccEmails, emailSubject: this.emailSubject, emailBody: this.emailBody, btnOK: true });
    }

    cancel(): void {
        this.dialogRef.close({ emailTo: null, emailCC: null, ccEmails: [], emailSubject: null, emailBody: null, btnOK: false });
    }

    public ccEmailsChange(emails: Email[]) {
        this.selectedCCEmails = Array.from(emails);
        //console.log("ccEmailsChange", this.selectedCCEmails, emails);
    }
}